import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6 12q-2.5 0-4.25-1.75T0 6t1.75-4.25T6 0t4.25 1.75T12 6q0 1.01-.313 1.905a6.3 6.3 0 0 1-.862 1.645l5.35 5.35a.86.86 0 0 1 .275.625.86.86 0 0 1-.275.625.875.875 0 0 1-1.275 0l-5.35-5.325q-.75.55-1.645.862A5.7 5.7 0 0 1 6 12m0-1.8q1.75 0 2.975-1.225T10.2 6 8.975 3.025Q7.749 1.8 6 1.8T3.025 3.025Q1.8 4.249 1.8 6q0 1.75 1.225 2.975Q4.249 10.199 6 10.2"
    }, null, -1)
  ]))]))
}
export default { render: render }